import { 
  TransporterPackage,
  TransporterPackageWithVehicles,
  Transporter
} from '../transporter'
import { 
  FirestoreDataConverter, 
  DocumentSnapshot, 
  SnapshotOptions, 
  WithFieldValue,
  Timestamp
} from 'firebase/firestore'

// Transporter Package Converter
export const transporterPackageConverter: FirestoreDataConverter<TransporterPackage> = {
  toFirestore(transporterPackage: WithFieldValue<TransporterPackage>) {
    const { id, client_user_id, ...data } = transporterPackage
    // Handle client_user_id: use empty string if undefined or empty
    const clientUserId = client_user_id && typeof client_user_id === 'string' && client_user_id.trim() !== '' 
      ? client_user_id 
      : ''
    
    return {
      ...data,
      created_at: data.created_at || Timestamp.now(),
      updated_at: data.updated_at || Timestamp.now(),
      created_by: data.created_by || '',
      client_user_id: clientUserId,
      status: data.status || 'DRAFT',
      vehicle_ids: data.vehicle_ids || [],
      pickup_locations: data.pickup_locations || {},
      // Preserve extended dropoff fields (including optional pickup_date for Optic flow)
      dropoff_locations: data.dropoff_locations || {},
      interim_locations: data.interim_locations || {},
      contact_status: data.contact_status || {},
      vehicle_status: data.vehicle_status || {},
      vehicle_assignments: data.vehicle_assignments || {},
      vehicle_priorities: data.vehicle_priorities || {},
      vehicle_ready: data.vehicle_ready || {},
      vehicle_damage: data.vehicle_damage || {},
      vehicle_needs: data.vehicle_needs || {},
      vehicle_files: data.vehicle_files || {},
      package_notes: data.package_notes || {},
      archive: data.archive || false
    }
  },
  fromFirestore(snapshot: DocumentSnapshot, options: SnapshotOptions): TransporterPackage {
    const data = snapshot.data(options)
    
    if (!data) {
      return {
        id: snapshot.id,
        name: '',
        created_at: Timestamp.now(),
        updated_at: Timestamp.now(),
        created_by: '',
        client_user_id: '',
        status: 'DRAFT',
        vehicle_ids: [],
        company_id: ''
      }
    }

    // Handle client_user_id: use empty string if undefined or empty
    const clientUserId = data.client_user_id && typeof data.client_user_id === 'string' && data.client_user_id.trim() !== ''
      ? data.client_user_id
      : ''

    return {
      id: snapshot.id,
      name: data.name || '',
      description: data.description,
      created_at: data.created_at || Timestamp.now(),
      updated_at: data.updated_at || Timestamp.now(),
      created_by: data.created_by || '',
      client_user_id: clientUserId,
      status: data.status || 'DRAFT',
      vehicle_ids: data.vehicle_ids || [],
      company_id: data.company_id || '',
      pickup_locations: data.pickup_locations || {},
      dropoff_locations: data.dropoff_locations || {},
      interim_locations: data.interim_locations || {},
      contact_status: data.contact_status || {},
      vehicle_status: data.vehicle_status || {},
      vehicle_assignments: data.vehicle_assignments || {},
      vehicle_priorities: data.vehicle_priorities || {},
      vehicle_ready: data.vehicle_ready || {},
      vehicle_damage: data.vehicle_damage || {},
      vehicle_needs: data.vehicle_needs || {},
      vehicle_files: data.vehicle_files || {},
      package_notes: data.package_notes || {},
      photo_upload_id: data.photo_upload_id,
      readable_id: data.readable_id,
      archive: data.archive || false
    }
  }
}

// Transporter Converter
export const transporterConverter: FirestoreDataConverter<Transporter> = {
  toFirestore(transporter: WithFieldValue<Transporter>) {
    const { id, ...data } = transporter
    return {
      ...data,
      created_at: data.created_at || Timestamp.now(),
      updated_at: data.updated_at || Timestamp.now(),
      status: data.status || 'ACTIVE',
    }
  },
  fromFirestore(snapshot: DocumentSnapshot, options: SnapshotOptions): Transporter {
    const data = snapshot.data(options)
    
    if (!data) {
      return {
        id: snapshot.id,
        user_id: '',
        email: '',
        created_at: Timestamp.now(),
        updated_at: Timestamp.now(),
        status: 'ACTIVE',
      }
    }

    return {
      id: snapshot.id,
      user_id: data.user_id || '',
      email: data.email || '',
      phone: data.phone,
      first_name: data.first_name,
      last_name: data.last_name,
      created_at: data.created_at || Timestamp.now(),
      updated_at: data.updated_at || Timestamp.now(),
      status: data.status || 'ACTIVE',
      transporter_role: data.transporter_role,
      elevated: data.elevated || false,
    }
  }
}
